export default __webpack_public_path__ + "static/media/seshavaham.f4493c44.png";